
import { Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Inject } from '@angular/core';

import { CourseTrackService } from '../course-track.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent implements OnInit {
  APPORVAL: any;
  REJECT: any;
  CourseTrack!: FormGroup;

  constructor(public dialogRef: MatDialogRef<DialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private services: CourseTrackService, public snackbar: MatSnackBar, private fb: FormBuilder, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    console.log(this.data)
    this.CourseTrack = this.fb.group({
      anyOtherReasons: [" ", Validators.required],

    })
  }


  approval(data: any) {
    this.APPORVAL = data.courseTrackId
    console.log(this.APPORVAL);

    let data2 = {
      "approvalStatus": "APPROVED",
      "remarks": this.CourseTrack.value.anyOtherReasons
    }
    if (confirm('do you want to approval Course Track Details')) {
      this.services.status(this.APPORVAL, data2).subscribe((res: any) => {
        res;
        console.log("updated data");
        this.dialogRef.close("pending");
        this.snackbar.open('Course Track Details Approved Successfully ', 'Close', {
          duration: 2000,
          verticalPosition: 'top',
          horizontalPosition: 'end',
        });
      })
    }

    // this.dialogRef.close();
  }
  reject(data: any) {
    this.APPORVAL = data.courseTrackId
    console.log(this.REJECT);
    let data2 = {
      "approvalStatus": "REJECTED",
      "remarks": this.CourseTrack.value.anyOtherReasons
    }
    if (confirm('do you want to rejected Course Track Details')) {
      this.services.status(this.APPORVAL, data2).subscribe((res: any) => {
        res;
        console.log("updated data");
        this.dialogRef.close("pending");
        this.snackbar.open('Course Track Details Rejected', 'Close', {
          duration: 2000,
          verticalPosition: 'top',
          horizontalPosition: 'end',
        });
      })
    }

    // this.dialogRef.close();
  }
  // close(){
  // if(this.data.approvalStatus=="APPROVED"){
  //   this.dialogRef.close('APPROVED');
  // } else if(this.data.approvalStatus=="REJECTED"){
  //   this.dialogRef.close('REJECTED');
  // }else{
  //   this.dialogRef.close('PENDING');
  // }
  // }
}
